module fdm.pilotPerformance {

    export class PilotTotalEventsController {


        public queryResult: any;
        public query: any;
        public data: any;
        public layout: any;
        public options: any;
        public events: any;
        public loading: any;
        // private xItems: Array<string> = [];
        // private xItemsPlaceholder: Array<string> = [];
        private focusTraceColor: string = "#5ebcfe";

        public constructor(
            private actionService: dg.actions.ActionService,
            private $scope: any,
            private navigationService: dg.navigation.NavigationService,
            private chartService: dg.lists.ChartService,
            private uiService: dgUtils.UiService,
            private severityLevelService: flightEvents.SeverityLevelService) {

        }

        $onChanges(changes) {
            if (changes.queryResult && changes.queryResult.currentValue) {
                // this.xItems = [];
                // this.xItemsPlaceholder = [];
                this.generateChart();
            }
        }


        //private generateTrace = (traceName: string, xValues, yValues, yAxis, color: string) => {
        //    let trace: any = {
        //        x: xValues,
        //        y: yValues,
        //        yaxis: yAxis,
        //        name: traceName,

        //        marker: {
        //            color: color
        //        },
        //        //line: {
        //        //    width: 1
        //        //},
        //        type: 'scatter'

        //    };
        //    if (yValues.length == 0) {
        //        trace.y = Array.apply(null, Array(xValues.length)).map(Number.prototype.valueOf, 0);
        //    }

        //    return trace;
        //}

        //private getBaselinePeriodEventsByMonth = (events) => {
        //    return _.map(events, (monthlyTrend: any) => {
        //        return monthlyTrend.baseline.value;
        //    })

        //}
        //private getFocusPeriodEventsByMonth = (events) => {
        //    return _.map(events, (monthlyTrend: any) => {
        //        if (!monthlyTrend.focus) {
        //            return null;
        //        }
        //        else {
        //            return monthlyTrend.focus.value;
        //        }
        //    })
        //}

        public generateChart = () => {
            const GREY_COLOR = 'rgb(127,127,127)';

            const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            //let xValues = ['2016-01-01', '2016-02-01', '2016-03-01', '2016-04-01', '2016-05-01', '2016-06-01', '2016-07-01', '2016-08-01', '2016-09-01', '2016-10-01', '2016-11-01', '2016-12-01'];

            let legsPerAircraft: Array<number> = [];
            const minorLevels = {
                x: [],
                y: [],
                // text: [],
                // yaxis: yAxis,
                name: 'Minor',

                marker: {
                    color: this.severityLevelService.getColor('Minor'),
                },
                //line: {
                //    width: 1
                //},
                type: 'scatter'

            };

            const majorLevels = {
                x: [],
                y: [],
                // text: [],
                // yaxis: yAxis,
                name: 'Major',

                marker: {
                    color: this.severityLevelService.getColor('Major'),
                },
                //line: {
                //    width: 1
                //},
                type: 'scatter'

            };

            const criticalLevels = {
                x: [],
                y: [],
                // text: [],
                // yaxis: yAxis,
                name: 'Critical',

                marker: {
                    color: this.severityLevelService.getColor('Critical'),
                },
                //line: {
                //    width: 1
                //},
                type: 'scatter'

            };

            const firstYear = this.queryResult.items.length > 0 ? new Date(this.queryResult.items[0].month.substring(0, 19)).getFullYear() : null;
            const hasDiffYears = firstYear && !!this.queryResult.items.find(e =>  new Date(e.month.substring(0, 19)).getFullYear() !== firstYear);

            for (let i = 0; i < this.queryResult.items.length; i += 1) {
                let item = <iteraFDM.domain.pilotPerformance.PilotEventsByMonthInfo>this.queryResult.items[i];
                const date = new Date((item.month as string).substring(0, 19));
                const year = String(date.getFullYear()).substring(2);
                const monthIndex = date.getMonth();
                //    this.xItems.push(item.phase.id);
                //    this.xItemsPlaceholder.push((<any>item.phase).description);
                const monthLabel = MONTHS[monthIndex] + (hasDiffYears ? ` '${year}` : '');
                minorLevels.x.push(monthLabel);
                majorLevels.x.push(monthLabel);
                criticalLevels.x.push(monthLabel);

                minorLevels.y.push(item.minorCount);
                majorLevels.y.push(item.majorCount);
                criticalLevels.y.push(item.criticalCount);

                // minorLevels.text.unshift(`${MONTHS[monthIndex]} (${item.minorCount})`);
                // majorLevels.text.unshift(`${MONTHS[monthIndex]} (${item.majorCount})`);
                // criticalLevels.text.unshift(`${MONTHS[monthIndex]} (${item.criticalCount})`);
            }

            // let trace: any = {
            //     x: xValues,
            //     y: yValues,
            //     yaxis: yAxis,
            //     name: traceName,

            //     marker: {
            //         color: color
            //     },
            //     //line: {
            //     //    width: 1
            //     //},
            //     type: 'scatter'

            // };
            // if (yValues.length == 0) {
            //     trace.y = Array.apply(null, Array(xValues.length)).map(Number.prototype.valueOf, 0);
            // }



            this.data = [minorLevels, majorLevels, criticalLevels];
            //console.log(this.data)
            //console.log(this.queryResult)
            this.layout = {
                //hovermode: 'closest',
                //barmode: 'group',
                height: 359,
                showlegend: false,
                margin: {
                    t: 10,
                    b: 40,
                    l: 35,
                    //l: 50,
                    r: 0
                },
                xaxis: {
                    type: 'category',
                    rangemode: 'nonegative',
                    fixedrange: true
                },
                yaxis: {
                    domain: [0, 1],
                    //titlefont: { color: MINOR_COLOR },
                    //title: 'Minor',
                    fixedrange: true,
                    rangemode: 'tozero'
                },
                //margin: {
                //    t: 10,
                //    b: 45,
                //    l: 45,
                //    r: 30
                //},
            };

            this.options = {
                showLink: false,
                displayLogo: false,
                displayModeBar: false
            };

            //this.events = (graph) => {

            //    graph.on('plotly_click', (data) => {
            //        if (data.points) {
            //            let name = data.points[0].x;
            //            let link = this.uiService.getLinkByProperty('phase', name, this.queryResult);
            //            this.navigationService.navigate(link, this.query);
            //        }
            //    });

            //    graph.on('plotly_hover', (data) => {
            //        let infoText = this.chartService.getItemByIndex(data, this.xItems, this.xItemsPlaceholder);

            //        this.chartService.setPlaceholderText(infoText, data.points[0].x);
            //    });
            //};
        }

        //public getLinkByProperty(property: string, phaseName: string, queryResult: any) {
        //     for (let i = 0; i < queryResult.items.length; i += 1) {
        //         if (queryResult.items[i][property].displayValue == phaseName) {
        //             return queryResult.items[i].dgMeta.links.viewEvents;
        //         }
        //     }
        // }
    }


    angular.module('fdm.pilotPerformance').component('pilotTotalEvents', {
        bindings: {
            queryResult: '<',
            loading: '<',
            query: '<'
        },
        controller: PilotTotalEventsController,
        templateUrl: '/digmo/src/lists/chart/plotly-chart-instance.html'
    });
}